module.exports = __webpack_public_path__ + "img/sort.1c9809f1.svg";